import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {base64ToFile, ImageCroppedEvent} from 'ngx-image-cropper';

export interface Photo {
  id: number;
  url: string;
  width: number;
  height: number;
}

@Component({
    selector: 'app-photo-uploader',
    templateUrl: './photo-uploader.component.html',
    standalone: false
})
export class PhotoUploaderComponent implements OnInit {
  @Input() current?: Photo;
  @Output() imageUploaded = new EventEmitter<Photo>();

  imageChangedEvent: any = '';
  imageUrl = '';
  croppedImage: any = '';
  croppedFile: Blob;
  isEditing = false;

  constructor(private http: HttpClient) {}
  ngOnInit() {}

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.imageUrl = '';
    this.isEditing = true;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedFile = base64ToFile(event.base64);
  }
  imageLoaded(image: any) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  save() {
    const formData = new FormData();
    formData.append('photo', this.croppedFile);

    this.http.post<Photo>('rest-api/v1/admin/photos/upload', formData).subscribe(photo => {
      this.imageUploaded.emit(photo);
      this.isEditing = false;
    });
  }

  discard() {
    this.imageChangedEvent = '';
    this.imageUrl = '';
    this.isEditing = false;
    // this.imageUploaded.emit(this.current);
  }
}
